import { reactionApi, ReactionApi } from '@petconsole/pure-fe-api';
import { appThunk } from '../../store/appThunk';
import { payloadCreatorUpdateReaction } from '../payloadCreators';

const updateReactionThunk = (sliceName: string, entityType: string, idName: string, api: ReactionApi = reactionApi) =>
  appThunk(`${sliceName}/update${entityType}Reaction`, payloadCreatorUpdateReaction(sliceName, idName, api));

export default updateReactionThunk;
